<template>
  <div class="cart-warp">
    <div class="container">
      <div class="help-tips">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.61084 13.8916C10.1528 13.8916 13.0854 10.959 13.0854 7.41699C13.0854 3.88135 10.1465 0.942383 6.60449 0.942383C3.06885 0.942383 0.13623 3.88135 0.13623 7.41699C0.13623 10.959 3.0752 13.8916 6.61084 13.8916ZM6.49023 8.79443C6.14746 8.79443 5.95703 8.6167 5.95703 8.27393V8.18506C5.95703 7.53125 6.3125 7.17578 6.78857 6.8457C7.37891 6.4458 7.6582 6.21729 7.6582 5.76025C7.6582 5.25879 7.26465 4.91602 6.65527 4.91602C6.21094 4.91602 5.87451 5.13818 5.67139 5.5C5.45557 5.75391 5.39844 5.95068 5.01758 5.95068C4.79541 5.95068 4.56055 5.79199 4.56055 5.49365C4.56055 5.37939 4.57959 5.27148 4.61133 5.16357C4.78271 4.54785 5.55078 4.01465 6.69336 4.01465C7.82959 4.01465 8.81348 4.60498 8.81348 5.70947C8.81348 6.50928 8.3501 6.89014 7.70898 7.32812C7.24561 7.63916 7.02344 7.86768 7.02344 8.24219V8.32471C7.02344 8.58496 6.82666 8.79443 6.49023 8.79443ZM6.50928 10.7051C6.14746 10.7051 5.79834 10.4131 5.79834 10.0195C5.79834 9.62598 6.14111 9.33398 6.50928 9.33398C6.88379 9.33398 7.22656 9.61963 7.22656 10.0195C7.22656 10.4194 6.87744 10.7051 6.50928 10.7051Z"
            fill="#CCCCCC"
          />
        </svg>
        <span>说明：商品单价、小计均为税前价格</span>
      </div>
      <div class="cart-list" v-if="list.length > 0">
        <van-checkbox-group v-model="selectList" ref="checkboxGroup">
          <van-swipe-cell
            :name="index"
            :before-close="beforeClose"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="cart-item">
              <van-checkbox :name="index"></van-checkbox>
              <div class="item-info">
                <ul v-if="item.productType === 'MROD'">
                  <li>旋转油封 <span>·</span> {{ item.product.model }}</li>
                  <li>说明： 每包{{ item.perPackageNums }}个</li>
                  <li>
                    小计：
                    <span class="price">
                      <small>¥</small>
                      {{ item.sellTotalPrice.toFixed(2).toString() }}
                    </span>
                    <del>
                      <small>¥</small>
                      {{ item.originTotalPrice.toFixed(2).toString() }}
                    </del>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    O形圈 <span>·</span> {{ item.product.innerDiameter }}X{{
                      item.product.wireDiameter
                    }}
                    {{ item.product.material }} {{ item.product.hardness }}
                  </li>
                  <li>说明： 每包{{ item.perPackageNums }}个</li>
                  <li>
                    小计：
                    <span class="price">
                      <small>¥</small>
                      {{ item.sellTotalPrice.toFixed(2).toString() }}
                    </span>
                    <del>
                      <small>¥</small>
                      {{ item.originTotalPrice.toFixed(2).toString() }}
                    </del>
                  </li>
                </ul>
              </div>
              <div class="item-right">
                <div class="item-edit" @click="editOrder(item, index)">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.5947 2.15137L14.0869 1.64551C14.3193 1.40625 14.3262 1.07129 14.0938 0.845703L13.9365 0.681641C13.7246 0.469727 13.3828 0.49707 13.1641 0.71582L12.665 1.20801L13.5947 2.15137ZM5.72656 9.26074L7.05957 8.67969L13.0889 2.65039L12.1523 1.72754L6.12988 7.75684L5.51465 9.04199C5.45996 9.1582 5.59668 9.31543 5.72656 9.26074ZM2.88965 14.3467H10.915C12.1387 14.3467 12.8564 13.6357 12.8564 12.2275V4.61914L11.7559 5.71973V12.1729C11.7559 12.8838 11.3662 13.2461 10.8945 13.2461H2.90332C2.21973 13.2461 1.84375 12.8838 1.84375 12.1729V4.41406C1.84375 3.70312 2.21973 3.33398 2.90332 3.33398H8.81641L9.91699 2.2334H2.88965C1.46094 2.2334 0.743164 2.94434 0.743164 4.35254V12.2275C0.743164 13.6426 1.46094 14.3467 2.88965 14.3467Z"
                      fill="#367CCC"
                    />
                  </svg>
                  编辑
                </div>
                <div class="item-count">
                  <small>x</small>
                  {{ item.nums }}
                </div>
              </div>
            </div>
            <template #right>
              <van-button square text="删除" type="danger" class="delete-button" />
            </template>
          </van-swipe-cell>
        </van-checkbox-group>
      </div>
      <!-- 空状态 -->
      <div class="default-state" v-else>
        <div class="state-content">
          <svg
            class="prefix__prefix__icon"
            width="50"
            height="50"
            viewBox="0 0 1201 1024"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1046 365.12c12.693 23.434-15.097-41.55-64.308-41.55l-761.35.3a73.321 73.321 0 0 0-64.593 39.898C139.195 389.695-.011 604.398-.011 649.798v291.86a82.619 82.619 0 0 0 82.86 82.334h1036a82.619 82.619 0 0 0 82.86-82.334v-291.86c0-45.456-155.75-284.74-155.75-284.74zM774.03 627.26a38.621 38.621 0 0 0-39.297 28.767c0 2.103.3 4.206.3 6.31a134.74 134.74 0 1 1-269.47 0c0-2.705.3-5.334.451-8.038a42.391 42.391 0 0 0-38.32-27.039H71.814l120.46-221.87s22.082-39.823 53.192-38.62h717.81c25.011 0 29.292 9.013 47.333 38.62l122.46 222.08H774.05zM341.4 206.85l-91.632-86.916a24.53 24.53 0 1 1 33.814-35.541l91.512 86.916a24.5 24.5 0 0 1-33.739 35.541m252.27-38.395a24.41 24.41 0 0 1-7.586-17.125l-3.305-126.18a24.545 24.545 0 0 1 49.061-1.277l3.23 126.18a24.485 24.485 0 0 1-41.325 18.402m237.34 33.89a24.485 24.485 0 0 1-.901-34.64l86.916-91.633a24.591 24.591 0 0 1 35.692 33.844l-86.916 91.632a24.485 24.485 0 0 1-34.64.901"
              fill="#C2C2C2"
            />
          </svg>
          还没有商品
        </div>
      </div>
    </div>
    <van-submit-bar
      safe-area-inset-bottom
      :disabled="selectList.length < 1"
      :loading="btnLoading"
      :price="totalPrice"
      :decimal-length="2"
      button-text="确定下单"
      :suffix-label="originalPrice"
      @submit="onSubmit"
    >
      <van-checkbox v-model="checkedAll" @click="checkAll">全选</van-checkbox>
      <template #tip v-if="taxationFee > 0"> 含税费：¥{{ taxationFee }}</template>
    </van-submit-bar>
    <Tabbar />

    <!-- TODO：购物车 Tabber 自定义 -->

    <van-popup
      safe-area-inset-bottom
      v-model="CartModalShow"
      class="cart-modal"
      position="bottom"
      round
      closeable
    >
      <Cart :cartOring="cartOring" :cartValue="cartValue" type="edit" :editIndex="editIndex"></Cart>
    </van-popup>

    <!-- mrod 购物弹窗 -->
    <CartMrod :cartData="cartOring" :cartValue="cartValue" type="edit" :editIndex="editIndex" />
  </div>
</template>

<script>
import api from "@/components/axios";
import Cart from "@/components/cart";
import CartMrod from "@/components/CartMrod";
import Tabbar from "@/components/tabbar";

export default {
  components: { Cart, CartMrod, Tabbar },
  data() {
    return {
      tabActive: "cart",
      checked: false,
      showTips: false,
      langingURL: null,
      checkedAll: false,
      selectList: [],
      cartOring: null,
      cartValue: {
        perPackageNums: 1,
        nums: 1,
      },
      editIndex: null,
      btnLoading: false,
    };
  },
  created() {
    this.langingURL = process.env.VUE_APP_LandingURL;
    this.getData();
  },
  watch: {
    // $route() {
    //   this.getData();
    // },
    selectList(n) {
      if (this.list.length === n.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
    },
  },
  computed: {
    CartModalShow: {
      get() {
        return this.$store.state.CartModalShow;
      },
      set(value) {
        this.$store.commit("storeCartModal", value);
      },
    },
    list() {
      return this.$store.state.cartList;
    },
    totalPrice() {
      if (this.selectList.length > 0) {
        const oringPriceArr = this.list
          .map((x, index) => {
            if (this.selectList.includes(index) && x.productType === "ORING") {
              return x.sellTotalPrice;
            }
            return null;
          })
          .filter((x) => x);

        const mrodPriceArr = this.list
          .map((x, index) => {
            if (this.selectList.includes(index) && x.productType === "MROD") {
              return x.sellTotalPrice;
            }
            return null;
          })
          .filter((x) => x);

        console.log(oringPriceArr, mrodPriceArr);

        const { oringPrice, mrodPrice, freight } = this.getFreight(oringPriceArr, mrodPriceArr);
        return (oringPrice + mrodPrice + freight) * 100;
      }

      return 0;
    },
    originalPrice() {
      if (this.selectList.length > 0) {
        const oringPriceArr = this.list
          .map((x, index) => {
            if (this.selectList.includes(index) && x.productType === "ORING") {
              return x.originTotalPrice;
            }
            return null;
          })
          .filter((x) => x);

        const mrodPriceArr = this.list
          .map((x, index) => {
            if (this.selectList.includes(index) && x.productType === "MROD") {
              return x.sellTotalPrice;
            }
            return null;
          })
          .filter((x) => x);

        console.log(oringPriceArr, mrodPriceArr);

        const { oringPrice, mrodPrice, freight } = this.getFreight(oringPriceArr, mrodPriceArr);

        return (oringPrice + mrodPrice + freight).toFixed(2).toString();
      }
      return null;
    },
    taxationFee() {
      if (this.selectList.length > 0) {
        const priceArr = this.list
          .map((x, index) => {
            if (this.selectList.includes(index)) {
              return x.sellTotalPrice;
            }
            return null;
          })
          .filter((x) => x);

        let price = 0;
        if (priceArr.length > 0) {
          price = priceArr.reduce((prev, current) => {
            return prev + current;
          });
        }

        return (price * 0.13).toFixed(2).toString();
      }

      return 0;
    },
  },
  methods: {
    getData() {
      this.$store.dispatch("getCartList");
    },
    onSubmit() {
      console.log(this.selectList);
      if (this.selectList.length > 0) {
        this.btnLoading = true;
        const orderList = this.list
          .map((x, index) => {
            if (this.selectList.includes(index)) {
              return x;
            }
            return null;
          })
          .filter((x) => x);
        const cartList = this.list
          .map((x, index) => {
            if (!this.selectList.includes(index)) {
              return x;
            }
            return null;
          })
          .filter((x) => x);
        console.log(orderList);
        console.log(cartList);
        const data = orderList;
        api.post("/order_record", data).then((res) => {
          console.log(res);
          if (res.data.code === 200) {
            this.$toast("订单已记录，优惠活动线下进行");
            this.selectList = [];
            this.updateCart(cartList);
            this.$router.push({
              path: "/cart-result",
              query: {
                id: res.data.data,
              },
            });
          }
        });
        this.btnLoading = false;
      } else {
        this.$toast.fail("请先勾选商品");
      }
    },
    onFailed(values) {
      this.$toast.fail(values.errors[0].message);
    },
    editOrder(order, index) {
      this.cartOring = JSON.parse(JSON.stringify(order.product));
      this.cartValue = JSON.parse(JSON.stringify(order));
      this.editIndex = index;
      if (order.productType === "MROD") {
        this.$store.commit("storeMrodCartModal", true);
      } else {
        this.$store.commit("storeCartModal", true);
      }
    },
    checkAll() {
      if (this.checkedAll) {
        this.$refs.checkboxGroup.toggleAll();
      } else {
        this.$refs.checkboxGroup.toggleAll(true);
      }
    },
    beforeClose({ name, position, instance }) {
      switch (position) {
        case "left":
        case "cell":
        case "outside":
          instance.close();
          break;
        case "right":
          this.$dialog
            .confirm({
              message: "确定删除吗？",
            })
            .then(() => {
              //删除操作
              this.list.splice(name, 1);
              this.updateCart(this.list);
              instance.close();
            });
          break;
      }
    },
    updateCart(data) {
      // 更新购物车
      api({
        method: "put",
        headers: { "content-type": "application/json;charset=UTF-8" },
        url: "/order_record/cart",
        data: data,
      }).then((res) => {
        this.$store.commit("storeCartList", data);
        this.$cookies.set("orderNums", data.length);
        console.log(res);
      });
    },
    getOriginalPrice(order) {
      const { nums } = order;
      let discount = 1;
      if (nums >= 100 && nums < 500) {
        discount = 0.75;
      } else if (nums >= 500) {
        discount = 0.55;
      }
      let price = order.totalPrice / discount;
      if (this.discountValue) {
        price = order.totalPrice / discount / this.discountValue;
      }
      return price.toFixed(2);
    },
    getFreight(oringPriceArr, mrodPriceArr) {
      // 获取运费
      let oringPrice = 0;
      let mrodPrice = 0;
      if (oringPriceArr.length > 0) {
        oringPrice = oringPriceArr.reduce((prev, current) => {
          return prev + current;
        });
      }

      if (mrodPriceArr.length > 0) {
        mrodPrice = mrodPriceArr.reduce((prev, current) => {
          return prev + current;
        });
      }
      let freight = 0;
      let oringFreight = 0;
      let mrodFreight = 0;

      if (oringPrice > 0 && oringPrice < 100) {
        // oring单笔订单订购不满100元的，需承担相应运费22元
        oringFreight = 22;
      }
      if (mrodPrice > 0 && mrodPrice < 388) {
        mrodFreight = 22;
      }

      if (oringFreight > mrodFreight) {
        freight = oringFreight;
      } else {
        freight = mrodFreight;
      }
      console.log(`运费：${freight}`);
      return { oringPrice: oringPrice, mrodPrice: mrodPrice, freight: freight };
    },
  },
};
</script>
<style lang="less">
.back-btn,
.footer {
  display: none;
}
.van-swipe-cell {
  .delete-button {
    height: 100%;
    border-radius: 10px;
  }
  .van-button::before {
    display: none;
  }
}

.van-submit-bar .van-submit-bar__text {
  & > .van-submit-bar__price {
    margin-right: 4px;
  }
  .van-submit-bar__suffix-label {
    text-decoration: line-through;
    color: #999;
    font-size: 12px;
  }
}
</style>
